import Duck from "@/components/common/3D/Duck";
import { PerspectiveCamera } from "@react-three/drei";
import { Canvas } from "@react-three/fiber";

import styles from "./CommonDuckScene.module.scss";
import FollowWave from "../FollowWave";
import { degToRad } from "three/src/math/MathUtils";

const CommonDuckWaveScene = ({
  wave,
  isInverse = false,
  positionOffset = -0.75,
}) => {
  return (
    <div className={styles.sceneDuck}>
      <Canvas style={{ width: "100%", height: "100%" }}>
        <PerspectiveCamera position={[0, 0, 10]} fov={30} makeDefault />
        <FollowWave
          wave={wave.current?.lastChild}
          inverse={isInverse}
          positionOffset={positionOffset}
        >
          <group position={[0, 0, 0]} rotation={[0, 0, 0]} scale={4}>
            <Duck
              position={[0, -0.5, 0]}
              rotation={[0, degToRad(-45), 0]}
              scale={1.25}
              cursorAnimations
              cursorAngleLimit={15}
            />
          </group>
        </FollowWave>
      </Canvas>
    </div>
  );
};

export default CommonDuckWaveScene;

CommonDuckWaveScene.displayName = "CommonDuckWaveScene";
